import { clone } from 'lodash';
;
export function checkMonthGaps(months, data, monthNames, deliveryWindows) {
    var newMonths = [];
    deliveryWindows.sort(function compare(a, b) {
        var dateA = new Date(a.shippingDate);
        var dateB = new Date(b.shippingDate);
        return dateA - dateB;
    });
    for (var i in months) {
        var month = months[i];
        var currentMonth = data[month];
        var nextMonth = data[months[+i + 1]];
        var diff = 0;
        if (typeof nextMonth !== 'undefined') {
            diff = monthsDiff(new Date(currentMonth.shippingDate), new Date(nextMonth.shippingDate));
        }
        newMonths.push(month);
        var newMonthDate = new Date(currentMonth.shippingDate);
        var newMonthYear = newMonthDate.getFullYear();
        for (var y = 0; y < diff; y++) {
            var monthNumber = newMonthDate.getMonth() + y + 1;
            var newMonth = monthNames[monthNumber % 12];
            if (monthNumber % 12 === 0) {
                newMonthYear = newMonthYear + 1;
            }
            var label = newMonth + ' ' + newMonthYear;
            newMonths.push(label);
        }
    }
    return newMonths;
}
export function addMinmumMonths(months, data, monthNames, deliveryWindows) {
    var minMonths = 6;
    deliveryWindows.sort(function compare(a, b) {
        var dateA = new Date(a.shippingDate);
        var dateB = new Date(b.shippingDate);
        return dateA - dateB;
    });
    var firstMonth = deliveryWindows[0].shippingDate;
    var lastMonth = deliveryWindows[deliveryWindows.length - 1].shippingDate;
    var reneDiff = (monthsDiff(new Date(firstMonth), new Date(lastMonth)) + 1);
    if (months.length === 1) {
        // Add at least the minimum amount of months
        // to the calendar.
        if (months.length < minMonths) {
            var monthsToAdd = minMonths - months.length;
            var newMonthDate = new Date(deliveryWindows[deliveryWindows.length - 1].shippingDate);
            // @ts-ignore
            var nmy = newMonthDate.getFullYear();
            for (var y = 0; y < monthsToAdd; y++) {
                var monthNumber = newMonthDate.getMonth() + y + 1;
                var newMonth = monthNames[monthNumber % 12];
                if (monthNumber % 12 === 0) {
                    nmy = nmy + 1;
                }
                var label = newMonth + ' ' + nmy;
                if (months.indexOf(label) === -1) {
                    months.push(label);
                }
            }
        }
    }
    else {
        var newMonths = [];
        var start = new Date(deliveryWindows[0].shippingDate);
        var nextMonth = start;
        if (reneDiff < minMonths) {
            reneDiff = minMonths;
        }
        for (var y = 0; y < reneDiff; y++) {
            var otherClone = clone(nextMonth);
            var nmy = otherClone.getFullYear();
            var monthNumber = clone(otherClone).getMonth();
            var newMonth = monthNames[monthNumber % 12];
            var label = newMonth + ' ' + nmy;
            if (newMonths.indexOf(label) === -1) {
                newMonths.push(label);
            }
            // Add it.
            nextMonth = new Date(otherClone.setMonth(clone(otherClone).getMonth() + 1, 1));
        }
        months = newMonths;
    }
    return months;
}
export function monthsDiff(d1, d2) {
    var date1 = new Date(d1);
    var date2 = new Date(d2);
    var years = yearsDiff(d1, d2);
    var months = (years * 12) + (date2.getMonth() - date1.getMonth());
    return months;
}
export function yearsDiff(d1, d2) {
    var date1 = new Date(d1);
    var date2 = new Date(d2);
    var yearsDiff = date2.getFullYear() - date1.getFullYear();
    return yearsDiff;
}
export function positionDrops(orderDrops, months) {
    var drops = orderDrops;
    var dropsSorted = {};
    for (var i in months) {
        var month = months[i];
        var dropsSortedByPosition = { 1: [], 2: [], 3: [], 4: [], 5: [] };
        dropsSorted[month] = dropsSortedByPosition;
        if (drops[month]) {
            var dropsForMonth = drops[month];
            var y = new Date(dropsForMonth[0].shippingDate).getFullYear().toString();
            var m = new Date(dropsForMonth[0].shippingDate).getMonth();
            var weekcount = getWeekCount(y, m);
            var weeksInMonth = getWeeksInMonth(y, m);
            // const numberOfWeeks = weekcount[1] - weekcount[0];
            for (var key in dropsForMonth) {
                var drop = dropsForMonth[key];
                var weekNumber = getWeekNumber(new Date(drop.shippingDate));
                // Total edge case.
                if (weekNumber === 1 && weekcount[1] === 53) {
                    weekNumber = 53;
                }
                var position = weeksInMonth - (weekcount[1] - weekNumber) + 1;
                drop.position = position;
                if (dropsSortedByPosition && !dropsSortedByPosition[drop.position]) {
                    dropsSortedByPosition[drop.position] = [];
                }
                dropsSortedByPosition[drop.position].push(drop);
            }
            dropsSorted[month] = dropsSortedByPosition;
        }
    }
    return dropsSorted;
}
export function getWeekCount(year, month) {
    // // month_number is in the range 1..
    year = year || new Date().getFullYear();
    var yearStart = new Date(year, 0, 1); // 1st Jan of the Year
    var first_day_of_month = new Date(year, month, 1);
    var first_week_number = Math.ceil((((first_day_of_month - yearStart) / 86400000) + yearStart.getDay() + 1) / 7);
    var last_day_of_month = new Date(year, month + 1, 0); // Last date of the Month
    var last_week_number = Math.ceil((((last_day_of_month - yearStart) / 86400000) + yearStart.getDay() + 1) / 7);
    return [first_week_number, last_week_number];
}
function getWeeksInMonth(year, month_number) {
    // month_number is in the range 1..12
    var firstOfMonth = new Date(year, month_number - 1, 1);
    var lastOfMonth = new Date(year, month_number, 0);
    var used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();
    return Math.ceil(used / 7);
}
export function getWeekNumber(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return weekNo;
}
export function formatDate(dateObj, format) {
    if (!isValidDate(dateObj)) {
        return 'Invalid Date';
    }
    var day = pad(dateObj.getDate().toString());
    var month = pad((dateObj.getMonth() + 1).toString());
    var year = dateObj.getFullYear().toString();
    switch (format) {
        case 'YYYY-MM-DD':
            return year + '-' + month + '-' + day;
        case 'DD.MM.YYYY':
            return day + '.' + month + '.' + year;
        default:
            return day + '/' + month + ' - ' + year;
    }
}
export function isValidDate(dateObj) {
    return dateObj instanceof Date && !isNaN(dateObj.getTime()) && new Date().getFullYear().toString().length === 4;
}
export function pad(n) {
    return n < 10 ? '0' + n : n;
}
//# sourceMappingURL=deliveryWindowsHelper.js.map